import styled, { keyframes } from 'styled-components';

const LoadingSVG = styled.svg`
  width: 300px;
  height: 200px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const LoadingWrapper = styled.div`
  width: 100%;
  background: #ffffff9e;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const len = 242.776657104492;
const time = '1.8s';
const keyframesAnim = keyframes`
  12.5% {
    stroke-dasharray: ${len * 0.14}, ${len};
    stroke-dashoffset: -${len * 0.11};
  }
  43.75% {
    stroke-dasharray: ${len * 0.35}, ${len};
    stroke-dashoffset: -${len * 0.35};
  }
  100% {
    stroke-dasharray: ${len * 0.01}, ${len};
    stroke-dashoffset: -${len * 0.99};
  }
`;

const AnimatedPath = styled.path`
  stroke: #000084;
  fill: none;
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
  animation: ${keyframesAnim} ${time} linear infinite;
  stroke-dashoffset: 0;
  stroke-dasharray: ${len * 0.01}, ${len};
`;

export default function LoadingAnimation() {
  return (
    <LoadingWrapper>
      <LoadingSVG
        width="300px"
        height="200px"
        viewBox="0 0 187.3 93.7"
        preserveAspectRatio="xMidYMid meet"
      >
        <AnimatedPath
          d="M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1
          c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
        />
        <path
          id="outline-bg"
          opacity="0.05"
          fill="none"
          stroke="#000084"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 				c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
        />
      </LoadingSVG>
    </LoadingWrapper>
  );
}
